import { render, staticRenderFns } from "./salerList.vue?vue&type=template&id=8925c08a&scoped=true"
import script from "./salerList.vue?vue&type=script&lang=js"
export * from "./salerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8925c08a",
  null
  
)

export default component.exports